import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { podeAcessar, telaInicial } from '../../services/permissoes';
import SemPermissao from '../../pages/auth/SemPermissao';

/**
 * Rotas por perfil (padrão P-S1, src/docs/padroes-front.md; ondas O0 e O0c).
 * - "/" leva cada perfil à sua tela inicial (administrador: painel; os demais: a 1ª tela de trabalho que acessam);
 * - rota fora do perfil mostra "sem permissão" (o back recusa as chamadas de qualquer forma);
 * - senha provisória (O0b): tudo leva a "Definir sua senha" até a troca.
 */
export default function GuardaPerfil({ children }) {
  const { acesso, trocarSenha } = useAuth();
  const { pathname } = useLocation();

  // O0b: com senha provisória, só a tela de definir a senha (o back também recusa o resto)
  if (trocarSenha && pathname !== '/definir-senha') {
    return <Navigate to="/definir-senha" replace />;
  }

  if (pathname === '/' && acesso?.perfil && telaInicial(acesso) !== '/') {
    return <Navigate to={telaInicial(acesso)} replace />;
  }
  if (!podeAcessar(acesso, pathname)) {
    return <SemPermissao />;
  }
  return children;
}
